import type { Component } from 'vue'
import { createApp as baseCreateApp } from 'vue'

import gettext from 'gettext-congress'
import autoPopupPlugin from 'layout_congress/plugins/autoPopupPlugin.mts'
import widgetPlugin from 'layout_congress/plugins/widgetPlugin.mts'

import PopupRouterLink from 'layout_congress/vue/PopupRouterLink.vue'

/**
 * createApp
 *
 * Create a Vue app with the gettext and widget modules preloaded.
 * */
export function createApp (rootComponent?: Component) {
  const app = baseCreateApp(rootComponent ?? {})
    .use(gettext as any)
    .use(widgetPlugin)
    .use(autoPopupPlugin)
    .component('PopupRouterLink', PopupRouterLink)

  return app
}
